export const SET_DELETE_CART = 'SET_DELETE_CART';
export const SET_UPDATE_CART = 'SET_UPDATE_CART';
export const SET_COMBINATION = 'SET_COMBINATION';
export const SET_TOTAL_DISCOUNT_PRICE = 'SET_TOTAL_DISCOUNT_PRICE';
export const SET_IS_PURCHASEABLE = 'SET_IS_PURCHASEABLE';
export const SET_HAS_ERROR = 'SET_HAS_ERROR';

export const MUTATION = {
    SET_DELETE_CART,
    SET_UPDATE_CART,
    SET_COMBINATION,
    SET_TOTAL_DISCOUNT_PRICE,
    SET_IS_PURCHASEABLE,
    SET_HAS_ERROR
};


// WEBPACK FOOTER //
// ./resources/assets/js/front/cart/store/mutation-types.js